import actions from '../../actionTypes';

export default (areaId) => {
  return {
    type: actions.GET_LOCATIONS_GEO_JSON,
    areaId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/locations/actions/getLocationsGeoJson.js